import axios from 'axios';

export default axios.create({
   baseURL: process.env.REACT_APP_API_URL || 'https://mywebpageserver-m26kjehx2a-uc.a.run.app'
});

// Local dev override — set REACT_APP_API_URL=http://localhost:5000 in .env.local

